import { useMemo } from 'react';

import { FinanceProvider, FinanceRate } from '@kanda-libs/ks-frontend-services';

import { BASE_TERMS, HUMM_DISCLAIMER, PROVIDERS } from './constants';

export interface CommissionCheckboxHook {
  copy: string;
}

export default function useCommissionCheckbox(
  selectedRate: FinanceRate,
): CommissionCheckboxHook {
  const provider = useMemo(
    () => (selectedRate?.provider || 'demo') as FinanceProvider,
    [selectedRate],
  );

  const copy = useMemo(
    () =>
      BASE_TERMS.replace(/{{provider}}/g, PROVIDERS[provider]).replace(
        /{{disclaimer}}/g,
        provider === 'humm' ? HUMM_DISCLAIMER : '',
      ),
    [provider],
  );

  return {
    copy,
  };
}
